import React, { useCallback, useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { ImainHome } from '@typings/setting/mainHome.interface';
import { CollectionPath, ImainhomeDoc } from '@typings/collections.enum';
import { useDocument } from '@nandorojo/swr-firestore';

import { useNavigate } from 'react-router-dom';
import Button from '@components/dataEntry/button/Button';
import copyToClipBoard from '@utils/copyToClipboard';
import { replaceContents } from '@utils/replaceContents';
import QuillContents from '@template/QuillContents/QuillContents';

const showBoxStyle = css`
  width: 100%;
  min-height: 300px;
`;

const MasterInfoContainer = styled.div<{
  showBox?: boolean;
}>`
  display: flex;
  flex-direction: column;
  gap: 12px;
  position: relative;
  /* ${({ showBox }) => showBox && showBoxStyle} */
`;

const SkinSec = styled.div`
  width: 100%;
  height: 140px;
  background: center / cover no-repeat var(--cardBackgroundColor);
`;
const ProfileImgSec = styled.div`
  position: absolute;
  top: 42px;
  left: 50%;
  transform: translateX(-50%);
  width: 140px;
  height: 140px;
  border-radius: 50%;
  border: 1px solid var(--lineColor);
  background: center / cover no-repeat var(--cardBackgroundColor);
  overflow: hidden;
`;
const DescriptionSec = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 48px 16px 0 16px;
  color: var(--subTextColor);
  p {
    font-size: 14px;
  }
  .title {
    font-size: 20px;
    font-weight: 700;
    color: var(--textColor);
  }
`;
const KeywordsSec = styled.div`
  padding: 0 16px 24px 16px;
  display: flex;
  flex-wrap: wrap;
  gap: 12px 4px;
  .keyword {
    background-color: var(--buttonBackgroundColor);
    color: var(--buttonTextColor);
    font-size: 12px;
    padding: 6px;
    border-radius: 10px;
  }
`;

type Props = {
  showBox?: boolean;
  style?: React.CSSProperties;
};
function MasterInfo({ showBox, style }: Props) {
  const navigate = useNavigate();
  const { data, set } = useDocument<ImainHome>(
    `${CollectionPath.MAINHOME}/${ImainhomeDoc.MAINHOME}`,
    { listen: true },
  );
  const [keywords, setKeywords] = useState<string[]>([]);
  const fluenceBannerURL = `${window.location.origin}/banner.png`;

  useEffect(() => {
    if (data?.masterInfo?.keywords) {
      const keywordArray = data?.masterInfo?.keywords
        .split(',')
        .map((word) => word.trim()) // 공백 제거
        .filter(Boolean);
      setKeywords(keywordArray);
    }
  }, [data]);

  const handlePasteLink = useCallback(() => {
    copyToClipBoard(fluenceBannerURL);
    return alert(`${fluenceBannerURL} 링크 복사 완료`);
  }, [fluenceBannerURL]);

  return (
    <MasterInfoContainer showBox={showBox} style={style}>
      <SkinSec
        style={{ backgroundImage: `url('${data?.masterInfo?.skinURL}')` || '' }}
      />
      <ProfileImgSec
        onClick={() => navigate('/')}
        style={{
          backgroundImage: `url('${data?.masterInfo?.imgURL}')` || '',
        }}
      />

      <DescriptionSec>
        <div className="title">{data?.masterInfo?.masterName}</div>
        <QuillContents
          value={data?.masterInfo?.description || ''}
        />
      </DescriptionSec>

      <KeywordsSec>
        {keywords &&
          keywords.map((word, i) => (
            <div className="keyword" key={i}>
              #{word}
            </div>
          ))}

        <Button icon="Plus14" shape="stroke" block onClick={handlePasteLink}>
          {data?.masterInfo?.buttonText || '이웃 추가'}
        </Button>
      </KeywordsSec>
    </MasterInfoContainer>
  );
}

export default MasterInfo;
